import React from "react";
import Header from "./Header";
import LocationDetails from "./LocationDetails";

export default function Event() {
  return (
    <>
      <Header />

      {/* Hero Section */}
      <section
        className="position-relative text-white text-center"
        style={{
          backgroundImage: "url('/images/event_8.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "40vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div> */}
      </section>

      {/* Intro Section */}
      <section className="py-5" style={{ backgroundColor: "#f8f6f1" }}>
        <div className="container text-center">
          <div className="col-lg-8 mx-auto">
            <h2
              className="fw-semibold mb-4"
              style={{ color: "#155d68", fontFamily: "EagleBold" }}
            >
              Discover events at ELY Wine Store Maynooth
            </h2>
            <p className="text-muted lead">
              Host your next birthday, engagement, graduation, confirmation, mini wedding, business meal or special gathering the ELY way: great wine, thoughtful food, and a warm, welcoming atmosphere. From relaxed celebrations to intimate wine tastings, ELY Wine Store Maynooth offers a beautifully curated neighbourhood space where every event feels personal. Located in the heart of Maynooth, our team will help you create an experience that’s seamless, enjoyable, and perfectly tailored to your needs.
            </p>
          </div>
        </div>
      </section>

      {/* Section 1 - Private Dining */}
      <section className="py-5" style={{ backgroundColor: "#155d68" }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 text-center mb-4">
              <h3
                className="fw-bold mb-3"
                style={{
                  color: "#fff",
                  fontFamily: "EagleBold",
                }}
              >
                Our spaces include
              </h3>
              <hr
                style={{ color: "white", width: "60%", margin: "0 auto" }}
              />
            </div>

            {/* Cards Row */}
            <div className="row justify-content-center">
              {/* Card 1 */}
              <div className="col-6 col-md-3 mb-4">
                <div className="card h-100 text-center border-0 shadow-sm">
                  <img
                    src="/images/private_dining_room.JPG"
                    className="card-img-top"
                    alt="Private Dining Room"
                    style={{ objectFit: "cover", height: "200px" }}
                  />
                  <div
                    className="card-body"
                    style={{ backgroundColor: "#155d68", color: "white" }}
                  >
                    <h5 style={{ fontFamily: "EagleLight" }}>
                      Private Dining Room
                    </h5>
                    <h5>Accommodates up to 30 guests. </h5>
                  </div>
                </div>
              </div>

              {/* Card 2 */}
              <div className="col-6 col-md-3 mb-4">
                <div className="card h-100 text-center border-0 shadow-sm">
                  <img
                    src="/images/the_snug.jpg"
                    className="card-img-top"
                    alt="Back Bar"
                    style={{ objectFit: "cover", height: "200px" }}
                  />
                  <div
                    className="card-body"
                    style={{ backgroundColor: "#155d68", color: "white" }}
                  >
                    <h5 style={{ fontFamily: "EagleLight" }}>Semi-Private Snug</h5>
                    <h5>Perfect for gatherings of up to 10/12 guests.</h5>
                  </div>
                </div>
              </div>

              {/* Card 3 */}
              <div className="col-6 col-md-3 mb-4">
                <div className="card h-100 text-center border-0 shadow-sm">
                  <img
                    src="/images/wine_shop.jpg"
                    className="card-img-top"
                    alt="The Basement"
                    style={{ objectFit: "cover", height: "200px" }}
                  />
                  <div
                    className="card-body"
                    style={{ backgroundColor: "#155d68", color: "white" }}
                  >
                    <h5 style={{ fontFamily: "EagleLight" }}>The Wine Shop and Snug</h5>
                    <h5>Ideal for up to 40 guests standing.</h5>
                  </div>
                </div>
              </div>

              {/* Card 4 */}
              <div className="col-6 col-md-3 mb-4">
                <div className="card h-100 text-center border-0 shadow-sm">
                  <img
                    src="/images/whole_venue.jpg"
                    className="card-img-top"
                    alt="Bar Space"
                    style={{ objectFit: "cover", height: "200px" }}
                  />
                  <div
                    className="card-body"
                    style={{ backgroundColor: "#155d68", color: "white" }}
                  >
                    <h5 style={{ fontFamily: "EagleLight" }}>Full Venue Exclusivity</h5>
                    <h5>42 seated, 70 standing</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 - Group Bookings */}
      <section className="py-5" style={{ backgroundColor: "#f8f6f1" }}>
        <div className="container text-center">
          <div className="col-md-8 mx-auto">
            <h3
              className="fw-bold mb-3"
              style={{ color: "#155d68", fontFamily: "EagleBold" }}
            >
              Plan Your Event
            </h3>
            <p className="text-muted lead">
             Groups of 8 or fewer can make a reservation with us through OpenTable or by calling us directly. For larger groups or private hire, please fill in our Event Inquiry Form below, our team will be delighted to help you plan your event.
            </p>
            <div className="mt-4">
              <a
                href="https://form.jotform.com/212653008716048"
                target="_blank"
                rel="noopener noreferrer"
                className="menu-card-link d-block my-2"
              >
                Submit an Inquiry
              </a>
              <a
                href="/EWS_2026_brochure.pdf"
                download="EWS_2026_brochure.pdf"
                className="menu-card-link d-block my-2"
              >
                Download ELY Wine Store 2026 Brochure
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3 - Venue Gallery */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h3
            className="fw-bold mb-3"
            style={{ color: "#155d68", fontFamily: "EagleBold" }}
          >
            Have you seen our venue?
          </h3>
          <p className="text-muted lead mx-auto" style={{ maxWidth: "700px" }}>
            Located in the heart of Maynooth, ELY Wine Store features private dining rooms upstairs, a cosy snug, bar, and wine shop, along with a covered and heated terrace on the ground floor. We host groups with options ranging from sharing plates and tailored wine tastings to relaxed celebrations and special gatherings. Explore a sample of our menus here.
          </p>
          <p className="text-muted lead mx-auto" style={{ maxWidth: "700px" }}>
            See a sample of our Private Dining Menu{" "}
            <a href="/images/EWP_dinner.pdf" target="_blank" rel="noopener noreferrer">
              here
            </a>
            .
          </p>

          {/* Image Grid */}
          <div className="row justify-content-center mt-5">
            {[
              { src: "/images/event_1.jpg" },
              { src: "/images/event_2.jpg" },
              { src: "/images/event_3.jpg"},
              {
                src: "/images/event_4.jpg",
              },
              { src: "/images/event_5.jpg" },
              {
                src: "/images/event_6.jpg"
              },
              {src: "/images/event_7.jpg" },
              { src: "/images/event_8.jpg" }
            ].map((img, i) => (
              <div key={i} className="col-6 col-md-3 mb-4 text-center">
                <img
                  src={img.src}
                  alt="ely-group-event"
                  className="img-fluid rounded shadow-sm"
                  style={{
                    objectFit: "cover",
                    height: "200px",
                    width: "100%",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 4 - CTA */}
      <section
        className="text-center text-white py-5 position-relative"
        style={{
          backgroundImage:
            "url('https://www.urbanbrewing.ie/wp-content/uploads/2022/11/UB_Contact_Header-scaled.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "#155d68", opacity: 0.95 }}
        ></div>
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <h2
            className="fw-bold mb-4"
            style={{ fontFamily: "EagleBold" }}
          >
            Plan Your Next Event With Us
          </h2>
          <p className="lead mb-4">
            Let our team help you craft an unforgettable experience at ELY Wine
            Bar. Click below to send us your enquiry.
          </p>
          <a
            href="https://form.jotform.com/212653008716048"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-light rounded-pill px-5 py-2 fw-semibold"
            style={{ color: "#155d68" }}
          >
            Submit Your Booking Request
          </a>
        </div>
      </section>

      <LocationDetails />
    </>
  );
}
